import React, { Fragment } from "react";
import { connect, Provider } from "react-redux";
import autoBind from "auto-bind";
import { createStore, applyMiddleware } from "redux";
import { thunk } from "redux-thunk";
import { composeWithDevTools } from "@redux-devtools/extension";

import BaseComponent from "@js/components/base_component.jsx";
import StudioOpensOverviewByPrivacyTable from "./studio_opens_overview_by_privacy_table.jsx";
import rootReducer from "@js/reducers/studio/stats/studio_opens_overview_by_privacy.js";

class StudioOpensOverviewByPrivacy extends BaseComponent {

  constructor(props) {
    super(props);

    this.store = createStore(
      rootReducer,
      {
        loading:          true,
        loaded:           false,
        stat_or_slice_id: props.stat_or_slice_id,
      },
      composeWithDevTools(applyMiddleware(thunk)),
    );
  }

  render() {
    return (
      <Provider store={ this.store }>
        <StudioOpensOverviewByPrivacyTable />
      </Provider>
    );
  }

}

export default StudioOpensOverviewByPrivacy;
